import http from '../common/api';
import {ApiSettings} from "application";

const lookupUserInfo = async () => {
  try {
    const response = await http.get(ApiSettings.userInfo);

    if (response.status < 400) {
      const {username, email, rut, tenants, profile} = response.data.user.data;
      const {unique_id} = response.data.user;
      return {
        unique_id,
        username,
        email: profile?.email || email,
        tenants,
        lastName: profile?.motherLastName,
        name: profile?.name,
        rut: profile?.rut || rut,
        firstName: profile?.fatherLastName,
        fullName: profile?.name ? `${profile.name} ${profile?.fatherLastName}` : username,
        profile: {
          ...(profile || { email, rut })
        },
      };
    }

  } catch (e) {
  }
}

export default lookupUserInfo;
